import { VideoResource } from '../../backend_api/models';

export const VIDEO_REQUEST_SUCCESS = 'VIDEO_REQUEST_SUCCESS';
export type VIDEO_REQUEST_SUCCESS = { video: VideoResource };